module.exports = __webpack_public_path__ + "img/Timbersaw.0a16170d.png";